import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.find-index.js";
// 字型 & 樣式
import 'typeface-noto-sans-tc'; // 中文字型
import 'typeface-bai-jamjuree'; // 英文字型
import '@/assets/SituationRoom_scss/SR_index.scss'; // SituationRoom 專用 SCSS

// 地圖與資料
import { drawD3Map, drawBackgroundMap } from '@/views/situationRoom/mapDrawer';
import { statsList, solarCharts, bmsCharts, powerCharts, solarInfoBasic, bmsInfoBasic, powerInfoBasic, bmsCommStatusToText, solarAnalysisCharts, bmsAnalysisCharts, powerAnalysisCharts, IDLE_SECONDS_MIN, SECONDS_MAX, INTERVAL_SECONDS_MIN, defaultAutoDemoSettings } from '@/views/situationRoom/dataSettings';
import { TYPE_MAP } from './utils/mapSystem/core/drawD3Map/constants';

// 圖表
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more'; // 引入, arearange 用
import Highcharts3d from 'highcharts/highcharts-3d';
import StockModule from 'highcharts/modules/stock';
import HeatmapModule from 'highcharts/modules/heatmap';
import { chartTheme } from '@/views/situationRoom/utils/highCharts/chartConfig';
import { chartRenderers } from '@/views/situationRoom/utils/highCharts/chartRenderer';

// 動畫與互動
import { initCustomCursor, runBackgroundAnimation, scrambleTextEffect } from '@/views/situationRoom/animation';

// 元件
import LoadingScreen from '@/views/situationRoom/animation/LoadingScreen.vue';
import InformationModal from '@/views/situationRoom/InformationModal.vue';
import InformationWindow from '@/views/situationRoom/InformationWindow.vue';
import SettingsModal from '@/views/situationRoom/SettingsModal.vue';
import SiteList from '@/views/situationRoom/utils/mapSystem/components/SiteList.vue';
import logoWhite from '@/assets/SituationRoom_scss/src/logo-white.png';
import { getBmsWholePlantSumApi, getPowerWholePlantSumApi, getSolarWholePlantSumApi, getSolarSinglePlantSumApi, getPowerSinglePlantSumApi, getBmsSinglePlantSumApi, getAllInfoApi, getAvailabilityApi, getSolarTopInformationApi, getBmsTopInformationApi, getPowerTopInformationApi, getEnergyMappingApi, getSolarAnalysisChartsApi, getPowerAnalysisChartsApi } from '@/api/situationRoom';
import { numberThousandsComma } from '@/utils/numberThousandsComma';
import { transformApiData } from './utils/transformApiData';
import { toTwoDecimals } from '@/utils/convertNumber';
import { isNumber } from '@/utils/is';
import { delay } from '@/utils/tool';


import dayjs from 'dayjs';
import { mapState } from 'vuex';
import axios from 'axios';
import clonedeep from 'lodash.clonedeep';
// 啟用模組
HighchartsMore(Highcharts);
Highcharts3d(Highcharts);
StockModule(Highcharts);
HeatmapModule(Highcharts);
// 設定共用樣式
Highcharts.setOptions(chartTheme);

// TODO: 總量數值單位依照數字長度決定 例如超過6位數 則偵測改為 MWh?
// TODO: 輪播要先背景抓前一個 api data (?)
// TODO: 查詢的是同縣市 就不返回地圖(?)
// TODO: 輪播 parent 若有多類型則會繼續播所有 child 再換下個
// TODO: 輪播加入 開啟詳細資訊視窗(?)

var defaultSiteTypes = Object.keys(TYPE_MAP);
export default {
  name: 'SituationRoom',
  components: {
    LoadingScreen: LoadingScreen,
    InformationModal: InformationModal,
    InformationWindow: InformationWindow,
    SettingsModal: SettingsModal,
    SiteList: SiteList
  },
  data: function data() {
    return {
      logoWhite: logoWhite,
      copyrightText: "Copyright \xA9 ".concat(dayjs().format('YYYY'), " ACMEPOINT Energy Services Co., Ltd. All\n            Rights Reserved."),
      // api 資料清除
      apiTimer: null,
      lastTriggerHour: null,
      // 輪播
      searchInput: '',
      settings: {},
      idleTimer: null,
      autoDemoTimer: null,
      idleText: '',
      cursorX: 0,
      // 游標目前X
      cursorY: 0,
      // 游標目前Y
      autoplayPageIdx: 0,
      // 總覽輪播頁數
      autoplaySiteIdx: 0,
      // 案場輪播頁數
      isSecretQuickAutoplay: false,
      // 是否從右上角點選 icon 秘密按鈕輪播 (由此播放為滑鼠加速版、間隔8s)

      // 狀態控制
      isMapLoading: true,
      isLoading: true,
      // 是否顯示載入動畫（初始進入頁面時為 true）
      // isScrolling: false, // 是否正在滾動（用於滾動節流或動畫判斷）
      // scrollTimeout: null, // 滾動事件的 timeout ID（用於 debounce/throttle）
      isOpenSettingsModal: false,
      isOpenModal: false,
      // 是否顯示彈窗（modal）元件
      changedSiteName: false,
      // 是否切換案場名稱
      isInfoWindowDataLoading: false,
      // 是否正在載入資訊窗資料

      // 地圖與場域
      selectedCounty: null,
      // 當前選擇的縣市（用於地圖篩選或資訊顯示）
      hoverSite: null,
      // 滑鼠目前懸停的場域資料（用於地圖或列表 hover 效果）
      clickedSiteInfo: null,
      // 滑鼠點擊地標 icon 的場域資料（用於地圖或列表點擊效果）
      showSiteLabels: true,
      // 是否顯示案場標籤（預設顯示）
      expandedSiteList: [],
      // 展開的案場列表
      selectedSiteIndex: -1,
      // 當前選中的案場索引

      // 資訊視窗
      weatherData: {},
      // 天氣資料
      hourlyWeatherData: {},
      // 小時天氣資料

      // 互動與動畫
      tooltipX: 0,
      // tooltip 的 X 座標（用於顯示提示框位置）
      tooltipY: 0,
      // tooltip 的 Y 座標（用於顯示提示框位置）
      scrambleControllers: [],
      // 亂數文字動畫的控制器陣列（用於標題動畫效果）

      // 頁籤與圖表
      currentPageIdx: 0,
      // 目前選擇的頁籤索引（對應不同資訊頁面）
      tabs: Object.values(TYPE_MAP),
      allSiteData: [],
      currentStats: statsList.solarInfo,
      // allStats[currentPageIdx]

      // (外層 chart data)
      // charts 預設設定內容, 之後依據 types 取得對應資料(1-3個)
      chartDatasets: [solarCharts, bmsCharts, powerCharts],
      currentChartDataset: solarCharts.map(function (obj, idx) {
        return chartRenderers.solarInfo[idx](obj);
      }),
      // chartDatasets[currentPageIdx]
      // key: 'whole' or siteName, value: {solarInfo: {}, mysqlInfo: {}, powerInfo: {}}
      dataMap: new Map(),
      // (window data)
      // info 預設設定內容, 之後依據 types 取得對應資料(1-3個)
      topInfoBasicDatasets: [solarInfoBasic, bmsInfoBasic, powerInfoBasic],
      topInfoDatasets: [],
      // key: siteName, value: {solarInfo: {}, mysqlInfo: {}, powerInfo: {}}
      topInfoMap: new Map(),
      // (modal data)
      // analysis 預設設定內容, 之後依據 types 取得對應資料(1-3個)
      analysisChartDatasets: [solarAnalysisCharts, bmsAnalysisCharts, powerAnalysisCharts],
      // key: siteName, value: {solarInfo: {}, mysqlInfo: {}, powerInfo: {}}
      analysisChartMap: new Map()
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loadDefaultMap(); // 繪製地圖(避免API延遲)
              _this.loadFullMapData(); // 非同步載入完整資料
              window.addEventListener('resize', _this.handleResize);
              window.addEventListener('wheel', _this.handleScrollThrottled);
              _context.next = 6;
              return _this.getWholeData();
            case 6:
              _this.setChartData();
              _this.updateAndShowChart();
              _this.removeCursor = initCustomCursor();
              runBackgroundAnimation();
              _this.restoreLocalSettings();
              _this.settings.openDemo && _this.addMouseMoveListener();
              _this.startApiTimer();
            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('wheel', this.handleScrollThrottled);
    if (this.removeCursor) {
      this.removeCursor();
    }
    this.removeMouseMoveListener();
    if (this.apiTimer) {
      clearInterval(this.apiTimer);
      this.apiTimer = null;
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(['userDetail'])), {}, {
    allSiteOptions: function allSiteOptions() {
      return this.allSiteData.map(function (site) {
        return {
          id: site.id,
          name: site.name
        };
      });
    },
    selectedSiteName: function selectedSiteName() {
      var _this$clickedSiteInfo;
      return (_this$clickedSiteInfo = this.clickedSiteInfo) === null || _this$clickedSiteInfo === void 0 ? void 0 : _this$clickedSiteInfo.name;
    },
    selectedSiteType: function selectedSiteType() {
      var _this$clickedSiteInfo2, _this$clickedSiteInfo3;
      // window modal 顯示 type 與 clickedSiteInfo type 一致
      var clickedSiteType = (_this$clickedSiteInfo2 = this.clickedSiteInfo) === null || _this$clickedSiteInfo2 === void 0 ? void 0 : (_this$clickedSiteInfo3 = _this$clickedSiteInfo2.types) === null || _this$clickedSiteInfo3 === void 0 ? void 0 : _this$clickedSiteInfo3[this.currentPageIdx];
      return TYPE_MAP[clickedSiteType];
    },
    pageTitle: function pageTitle() {
      // page 顯示 type 會在 get data 後 set data 時改變
      var title = this.siteTypeTexts[this.currentPageIdx] + '資訊';
      return this.selectedSiteName ? "".concat(title, " / ").concat(this.selectedSiteName) : title;
    },
    siteTypes: function siteTypes() {
      // 目前選擇案場擁有的類型 若無案場名則資料應是總覽頁
      return this.clickedSiteInfo ? this.clickedSiteInfo.types : defaultSiteTypes;
    },
    allStats: function allStats() {
      return this.siteTypes.map(function (type) {
        return statsList[type];
      });
    },
    wholePlantData: function wholePlantData() {
      var key = this.selectedSiteName || 'whole';
      var siteData = this.dataMap.get(key);
      return this.siteTypes.map(function (type) {
        return (siteData === null || siteData === void 0 ? void 0 : siteData[type]) || null;
      });
    },
    siteTypeTexts: function siteTypeTexts() {
      return this.siteTypes.map(function (type) {
        return TYPE_MAP[type];
      });
    },
    currentTopInfoData: function currentTopInfoData() {
      // loading 狀態下, 用預設資料
      var topInfoData = this.isInfoWindowDataLoading ? this.topInfoBasicDatasets : this.topInfoDatasets;
      return topInfoData === null || topInfoData === void 0 ? void 0 : topInfoData[this.currentPageIdx];
    },
    currentAnalysisChartData: function currentAnalysisChartData() {
      return this.analysisChartDatasets[this.currentPageIdx];
    },
    hasSecretAutoplay: function hasSecretAutoplay() {
      return ['Ben', 'Boni', 'Ada'].includes(this.userDetail.displayName);
    },
    checkedIdleSeconds: function checkedIdleSeconds() {
      var t = this.settings.idleSeconds < IDLE_SECONDS_MIN ? IDLE_SECONDS_MIN : this.settings.idleSeconds > SECONDS_MAX ? SECONDS_MAX : this.settings.idleSeconds;
      return t * 1000;
    },
    checkedIntervalSeconds: function checkedIntervalSeconds() {
      var t = this.settings.intervalSeconds < INTERVAL_SECONDS_MIN ? INTERVAL_SECONDS_MIN : this.settings.intervalSeconds > SECONDS_MAX ? SECONDS_MAX : this.settings.intervalSeconds;
      return this.isSecretQuickAutoplay ? 8 * 1000 : t * 1000; // 若是右上角快速輪播, 則間隔為 8 秒
    }
  }),
  watch: {
    searchInput: function searchInput() {
      !this.searchInput && this.allBackToOverview();
    }
  },
  methods: {
    numberThousandsComma: numberThousandsComma,
    // 切換案場標籤顯示
    handleToggleSiteLabels: function handleToggleSiteLabels() {
      this.showSiteLabels = !this.showSiteLabels;
      if (this.state) this.state.showLabels = this.showSiteLabels;
      if (typeof this.toggleSiteLabels === 'function') {
        this.toggleSiteLabels(this.showSiteLabels);
      }
    },
    zoomIn: function zoomIn() {
      if (!this.svg || !this.zoom) return;
      this.svg.transition().call(this.zoom.scaleBy, 1.2);
    },
    zoomOut: function zoomOut() {
      if (!this.svg || !this.zoom) return;
      this.svg.transition().call(this.zoom.scaleBy, 0.8);
    },
    // 更新案場名稱列表
    updateSiteNameList: function updateSiteNameList(sites) {
      this.expandedSiteList = sites;
      this.selectedSiteIndex = -1;
    },
    // 清空案場名稱列表
    clearSiteNameList: function clearSiteNameList() {
      this.expandedSiteList = [];
      this.selectedSiteIndex = -1;
    },
    handleResize: function handleResize() {
      var _this2 = this;
      if (this._resizeTimeout) clearTimeout(this._resizeTimeout);
      this._resizeTimeout = setTimeout(function () {
        requestAnimationFrame(function () {
          drawD3Map(_this2.$refs.mapContainer, _this2, _this2.allSiteData);
          _this2.adjustChartContainer();
          _this2.updateAndShowChart();
          _this2.$nextTick(_this2.reflowCharts);
        });
      }, 100);
    },
    adjustChartContainer: function adjustChartContainer() {
      document.querySelectorAll('.ifm-bottom-charts').forEach(function (el) {
        var isSmallScreen = window.innerWidth <= 1920;
        el.style.minWidth = isSmallScreen ? '0' : '';
        el.style.width = isSmallScreen ? '100%' : '';
      });
    },
    reflowCharts: function reflowCharts() {
      var _window$Highcharts;
      if ((_window$Highcharts = window.Highcharts) !== null && _window$Highcharts !== void 0 && _window$Highcharts.charts) {
        Highcharts.charts.filter(Boolean).forEach(function (chart) {
          var _chart$reflow;
          return (_chart$reflow = chart.reflow) === null || _chart$reflow === void 0 ? void 0 : _chart$reflow.call(chart);
        });
      }
    },
    allBackToOverview: function allBackToOverview() {
      // 回到首頁(太陽能總覽)
      this.resetMap();
      // 資料顯示回到太陽能總覽
      // 已在總覽 solar
      if (!this.clickedSiteInfo && this.currentPageIdx === 0) return;
      this.clickedSiteInfo = null;
      this.currentPageIdx = 0; // 指定回到 總覽 solar (若不指定則移除)

      this.setChartData();
      this.updateAndShowChart();
    },
    handleScroll: function handleScroll(event) {
      if (this.isInfoWindowDataLoading) return;
      if (window.innerWidth <= 1440) return;
      var direction = event.deltaY > 0 ? 1 : -1;
      var isMultipleType = this.siteTypes.length > 1;
      this.currentPageIdx = (this.currentPageIdx + direction + this.siteTypes.length) % this.siteTypes.length;
      isMultipleType && this.updateAndShowChart();
    },
    setPage: function setPage(index) {
      if (this.currentPageIdx !== index) {
        this.currentPageIdx = index;
        this.updateAndShowChart();
      }
    },
    search: function search() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this3.searchInput) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                if (_this3.allSiteData.map(function (site) {
                  return site.id;
                }).includes(_this3.searchInput)) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                // await this.resetMap()
                _this3.resetMap();
                _context2.next = 7;
                return _this3.focusSiteBySiteId(_this3.searchInput);
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    restoreLocalSettings: function restoreLocalSettings() {
      var localSettings = JSON.parse(localStorage.getItem('situation_room_settings'));
      if (localSettings && Object.keys(localSettings).length > 0) {
        this.settings = localSettings;
        this.checkSettingsMin();
      } else {
        localStorage.setItem('situation_room_settings', JSON.stringify(_objectSpread({}, defaultAutoDemoSettings)));
        this.settings = defaultAutoDemoSettings;
      }
    },
    checkSettingsMin: function checkSettingsMin() {
      // 以防以前設定與目前預設限制有出入 檢查過後更新一次 localStorage
      if (this.settings.idleSeconds < IDLE_SECONDS_MIN || this.settings.intervalSeconds < INTERVAL_SECONDS_MIN) {
        this.fixIdleSeconds(this.settings.idleSeconds);
        this.fixIntervalSeconds(this.settings.intervalSeconds);
        localStorage.setItem('situation_room_settings', JSON.stringify(this.settings));
      }
    },
    startApiTimer: function startApiTimer() {
      var _this4 = this;
      this.apiTimer = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var now, hour, minute;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                now = new Date();
                hour = now.getHours();
                minute = now.getMinutes();
                if (!(minute === 10 && _this4.lastTriggerHour !== hour)) {
                  _context3.next = 11;
                  break;
                }
                // 整點 10 分清除 api data
                console.log("[".concat(hour, ":10] \u6E05\u9664\u5FEB\u53D6\u8CC7\u6599"));
                _this4.dataMap.clear();
                _this4.topInfoMap.clear();
                _this4.analysisChartMap.clear();
                _this4.lastTriggerHour = hour;
                _context3.next = 11;
                return _this4.getWholeData();
              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      })), 10000);
    },
    addMouseMoveListener: function addMouseMoveListener() {
      window.addEventListener('mousemove', this.trackMouse);
      window.addEventListener('mousemove', this.resetIdleTimer);
      window.addEventListener('keydown', this.resetIdleTimer);
      window.addEventListener('scroll', this.resetIdleTimer, true); // true=捕獲，確保監聽到所有捲動
      window.addEventListener('wheel', this.resetIdleTimer, {
        passive: true
      });
      window.addEventListener('visibilitychange', this.resetIdleTimer); // 頁面可見
      this.resetIdleTimer();
    },
    removeMouseMoveListener: function removeMouseMoveListener() {
      window.removeEventListener('mousemove', this.trackMouse);
      window.removeEventListener('mousemove', this.resetIdleTimer);
      window.removeEventListener('keydown', this.resetIdleTimer);
      window.removeEventListener('scroll', this.resetIdleTimer, true);
      window.removeEventListener('wheel', this.resetIdleTimer);
      window.removeEventListener('visibilitychange', this.resetIdleTimer);

      // 清除計時器
      clearTimeout(this.idleTimer);
      this.idleTimer = null;

      // 停止自動輪播
      this.stopAutoplay();
      this.isSecretQuickAutoplay = false;
    },
    getAndShowData: function getAndShowData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$selectedSiteTy;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // openSiteInfo -> 取得 clickedSiteInfo -> getAndShowData
                _this5.setTopInfoBasicData(); // for skeleton loading

                // get api data
                if (!(_this5.selectedSiteName && _this5.changedSiteName)) {
                  _context4.next = 11;
                  break;
                }
                if (_this5.dataMap.has(_this5.selectedSiteName)) {
                  _context4.next = 5;
                  break;
                }
                _context4.next = 5;
                return _this5.getSingleData();
              case 5:
                if (_this5.topInfoMap.has(_this5.selectedSiteName)) {
                  _context4.next = 8;
                  break;
                }
                _context4.next = 8;
                return _this5.getSingleInfoData();
              case 8:
                if (!(!_this5.analysisChartMap.has(_this5.selectedSiteName) && !((_this5$selectedSiteTy = _this5.selectedSiteType) !== null && _this5$selectedSiteTy !== void 0 && _this5$selectedSiteTy.includes('mysqlInfo')) // 儲能沒有 analysisChart
                )) {
                  _context4.next = 11;
                  break;
                }
                _context4.next = 11;
                return _this5.getSingleAnalysisChartData();
              case 11:
                // set data
                _this5.setChartData();
                _this5.updateAndShowChart();
                _this5.setTopInfoData();
                _this5.setAnalysisChartData();
                _this5.isInfoWindowDataLoading = false; // 資料載入完成，關閉載入狀態
              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    updateAndShowChart: function updateAndShowChart() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$chartDatasets$;
        var titleEl, controller, sum;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // update current data
                _this6.currentStats = _this6.allStats[_this6.currentPageIdx];
                _this6.currentChartDataset = (_this6$chartDatasets$ = _this6.chartDatasets[_this6.currentPageIdx]) === null || _this6$chartDatasets$ === void 0 ? void 0 : _this6$chartDatasets$.map(function (obj, idx) {
                  return chartRenderers[_this6.siteTypes[_this6.currentPageIdx]][idx](obj);
                });
                _context5.next = 4;
                return _this6.$nextTick();
              case 4:
                // 數字更新 -> dom 更新 -> 操作 $refs (所以 上面的不能放 computed)

                // 停止上一個動畫
                _this6.scrambleControllers.forEach(function (controller) {
                  var _controller$stop;
                  return controller === null || controller === void 0 ? void 0 : (_controller$stop = controller.stop) === null || _controller$stop === void 0 ? void 0 : _controller$stop.call(controller);
                });
                _this6.scrambleControllers = [];

                // 添加 scrambleTextEffect 動畫
                titleEl = _this6.$refs.chartTitleText;
                if (titleEl) {
                  controller = scrambleTextEffect(titleEl, _this6.pageTitle);
                  _this6.scrambleControllers.push(controller);
                }
                sum = _this6.wholePlantData[_this6.currentPageIdx]; // FIXME: 先暫時用 currentPageIdx 判斷
                // solar 數字過大 要變成兆瓦、科學記號e+ 處理
                if (_this6.pageTitle.includes('太陽能') && !_this6.selectedSiteName) {
                  Object.entries(_this6.currentStats).forEach(function (stat, index) {
                    var numberEl = _this6.$refs["numberText-".concat(index)];
                    var unitEl = _this6.$refs["unitText-".concat(index)];
                    var titleEl = _this6.$refs["titleText-".concat(index)];
                    var value = sum === null || sum === void 0 ? void 0 : sum[stat === null || stat === void 0 ? void 0 : stat[0]];
                    if (index === 0) {
                      if (numberEl && numberEl[0]) {
                        var _String;
                        var _controller = scrambleTextEffect(numberEl[0],
                        // FIXME: fix 科學記號e+ )
                        ((_String = String(value)) === null || _String === void 0 ? void 0 : _String.length) > 20 || !value ? '-' : numberThousandsComma(Math.round(value / 1000))
                        // FIXME: 數字過長，先暫時拿掉小數
                        );
                        _this6.scrambleControllers.push(_controller);
                      }
                      if (unitEl && unitEl[0]) {
                        var _controller2 = scrambleTextEffect(unitEl[0], 'MWh');
                        _this6.scrambleControllers.push(_controller2);
                      }
                      if (titleEl && titleEl[0]) {
                        var _controller3 = scrambleTextEffect(titleEl[0], stat[1].title);
                        _this6.scrambleControllers.push(_controller3);
                      }
                    } else {
                      if (numberEl && numberEl[0]) {
                        var _String2;
                        var _controller4 = scrambleTextEffect(numberEl[0],
                        // FIXME: fix 科學記號e+ )
                        ((_String2 = String(value)) === null || _String2 === void 0 ? void 0 : _String2.length) > 20 || !value ? '-' : numberThousandsComma(Math.round(value / 1000))
                        // FIXME: 數字過長，先暫時拿掉小數
                        );
                        _this6.scrambleControllers.push(_controller4);
                      }
                      if (unitEl && unitEl[0]) {
                        var _controller5 = scrambleTextEffect(unitEl[0], stat[1].unit);
                        _this6.scrambleControllers.push(_controller5);
                      }
                      if (titleEl && titleEl[0]) {
                        var _controller6 = scrambleTextEffect(titleEl[0], stat[1].title);
                        _this6.scrambleControllers.push(_controller6);
                      }
                    }
                  });
                } else if (_this6.pageTitle.includes('太陽能') && _this6.selectedSiteName) {
                  Object.entries(_this6.currentStats).forEach(function (stat, index) {
                    var numberEl = _this6.$refs["numberText-".concat(index)];
                    var unitEl = _this6.$refs["unitText-".concat(index)];
                    var titleEl = _this6.$refs["titleText-".concat(index)];
                    var value = sum === null || sum === void 0 ? void 0 : sum[stat === null || stat === void 0 ? void 0 : stat[0]];
                    if (index === 0) {
                      if (numberEl && numberEl[0]) {
                        var _String3;
                        var _controller7 = scrambleTextEffect(numberEl[0],
                        // FIXME: fix 科學記號e+ )
                        ((_String3 = String(value)) === null || _String3 === void 0 ? void 0 : _String3.length) > 20 || !value ? '-' : numberThousandsComma(Math.round(value))
                        // FIXME: 數字過長，先暫時拿掉小數
                        );
                        _this6.scrambleControllers.push(_controller7);
                      }
                      if (unitEl && unitEl[0]) {
                        var _controller8 = scrambleTextEffect(unitEl[0], stat[1].unit);
                        _this6.scrambleControllers.push(_controller8);
                      }
                      if (titleEl && titleEl[0]) {
                        var _controller9 = scrambleTextEffect(titleEl[0], stat[1].title);
                        _this6.scrambleControllers.push(_controller9);
                      }
                    } else {
                      if (numberEl && numberEl[0]) {
                        var _String4;
                        var _controller10 = scrambleTextEffect(numberEl[0],
                        // FIXME: fix 科學記號e+ )
                        ((_String4 = String(value)) === null || _String4 === void 0 ? void 0 : _String4.length) > 20 || !value ? '-' : numberThousandsComma(Math.round(value / 1000))
                        // FIXME: 數字過長，先暫時拿掉小數
                        );
                        _this6.scrambleControllers.push(_controller10);
                      }
                      if (unitEl && unitEl[0]) {
                        var _controller11 = scrambleTextEffect(unitEl[0], stat[1].unit);
                        _this6.scrambleControllers.push(_controller11);
                      }
                      if (titleEl && titleEl[0]) {
                        var _controller12 = scrambleTextEffect(titleEl[0], stat[1].title);
                        _this6.scrambleControllers.push(_controller12);
                      }
                    }
                  });
                } else {
                  Object.entries(_this6.currentStats).forEach(function (stat, index) {
                    var numberEl = _this6.$refs["numberText-".concat(index)];
                    var unitEl = _this6.$refs["unitText-".concat(index)];
                    var titleEl = _this6.$refs["titleText-".concat(index)];
                    var value = sum === null || sum === void 0 ? void 0 : sum[stat === null || stat === void 0 ? void 0 : stat[0]];
                    if (numberEl && numberEl[0]) {
                      var _controller13 = scrambleTextEffect(numberEl[0],
                      // FIXME: 數字過長，先暫時拿掉小數
                      !value ? '-' : numberThousandsComma(Math.round(value))
                      // numberThousandsComma(Math.round(sum[stat[0]] * 100) / 100)
                      );
                      _this6.scrambleControllers.push(_controller13);
                    }
                    if (unitEl && unitEl[0]) {
                      var _controller14 = scrambleTextEffect(unitEl[0], stat[1].unit);
                      _this6.scrambleControllers.push(_controller14);
                    }
                    if (titleEl && titleEl[0]) {
                      var _controller15 = scrambleTextEffect(titleEl[0], stat[1].title);
                      _this6.scrambleControllers.push(_controller15);
                    }
                  });
                }
              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 頁面載入 → 顯示地圖、Loading → 載入API資料 → 隱藏Loading → 顯示案場資料
    loadDefaultMap: function loadDefaultMap() {
      console.log('載入地圖框架（等待資料中...）');
      drawBackgroundMap(this.$refs.mapContainer);
      this.isMapLoading = true;
    },
    // 載入完整地圖資料（含妥善率），並更新地圖
    loadFullMapData: function loadFullMapData() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _infoRes$data;
        var infoRes, _infoRes$data$data, solarInfo, powerInfo, mysqlInfo, allIds, multipleTypeSiteRes, availabilityRes;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return getAllInfoApi();
              case 3:
                infoRes = _context6.sent;
                _context6.next = 9;
                break;
              case 6:
                _context6.prev = 6;
                _context6.t0 = _context6["catch"](0);
                console.error('getAllInfoApi error:', _context6.t0);
              case 9:
                _infoRes$data$data = (_infoRes$data = infoRes.data) === null || _infoRes$data === void 0 ? void 0 : _infoRes$data.data, solarInfo = _infoRes$data$data.solarInfo, powerInfo = _infoRes$data$data.powerInfo, mysqlInfo = _infoRes$data$data.mysqlInfo; // 取得所有案場 id
                allIds = [].concat(_toConsumableArray(solarInfo), _toConsumableArray(powerInfo), _toConsumableArray(mysqlInfo)).map(function (info) {
                  return info.id;
                });
                _context6.prev = 11;
                _context6.next = 14;
                return getEnergyMappingApi();
              case 14:
                multipleTypeSiteRes = _context6.sent;
                _context6.next = 17;
                return getAvailabilityApi(allIds);
              case 17:
                availabilityRes = _context6.sent;
                _this7.allSiteData = transformApiData(infoRes.data.data, availabilityRes.data.data, multipleTypeSiteRes.data.data);
                _context6.next = 24;
                break;
              case 21:
                _context6.prev = 21;
                _context6.t1 = _context6["catch"](11);
                console.error('getEnergyMappingApi or getAvailabilityApi error:', _context6.t1);
              case 24:
                console.log('更新地圖（真實妥善率）');

                // 直接用 this 傳入 Vue instance
                drawD3Map(_this7.$refs.mapContainer, _this7, _this7.allSiteData);
                _this7.isMapLoading = false;
              case 27:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[0, 6], [11, 21]]);
      }))();
    },
    showTooltip: function showTooltip(site, x, y) {
      this.hoverSite = site;
      this.tooltipX = x;
      this.tooltipY = y;
    },
    hideTooltip: function hideTooltip() {
      this.hoverSite = null;
    },
    openModal: function openModal() {
      this.isOpenModal = true;
    },
    closeModal: function closeModal() {
      this.isOpenModal = false;
    },
    openSettingsModal: function openSettingsModal() {
      if (this.isMapLoading) return;
      this.isOpenSettingsModal = true;
      this.settings.openDemo && this.removeMouseMoveListener();
    },
    closeSettingsModal: function closeSettingsModal() {
      // 若沒儲存直接關閉, 將 settings 恢復
      this.settings = JSON.parse(localStorage.getItem('situation_room_settings')) || _objectSpread({}, defaultAutoDemoSettings);
      this.isOpenSettingsModal = false;
      this.settings.openDemo && this.addMouseMoveListener();
    },
    fixIdleSeconds: function fixIdleSeconds(s) {
      this.settings.idleSeconds = s < IDLE_SECONDS_MIN ? IDLE_SECONDS_MIN : s > SECONDS_MAX ? SECONDS_MAX : s;
    },
    fixIntervalSeconds: function fixIntervalSeconds(s) {
      this.settings.intervalSeconds = s < INTERVAL_SECONDS_MIN ? INTERVAL_SECONDS_MIN : s > SECONDS_MAX ? SECONDS_MAX : s;
    },
    resetSettings: function resetSettings() {
      this.settings = _objectSpread({}, defaultAutoDemoSettings);
    },
    submitSettings: function submitSettings() {
      localStorage.setItem('situation_room_settings', JSON.stringify(this.settings));
    },
    getWholeData: function getWholeData() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _resSolarWhole$data, _resSolarWhole$data$d, _resSolarWhole$data$d2, _resBmsWhole$data, _resBmsWhole$data$dat, _resBmsWhole$data$dat2, _resPowerWhole$data, _resPowerWhole$data$d, _resPowerWhole$data$d2;
        var resSolarWhole, solarWholeData, resBmsWhole, bmsWholeData, resPowerWhole, powerWholeData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return getSolarWholePlantSumApi();
              case 2:
                resSolarWhole = _context7.sent;
                solarWholeData = resSolarWhole === null || resSolarWhole === void 0 ? void 0 : (_resSolarWhole$data = resSolarWhole.data) === null || _resSolarWhole$data === void 0 ? void 0 : (_resSolarWhole$data$d = _resSolarWhole$data.data) === null || _resSolarWhole$data$d === void 0 ? void 0 : (_resSolarWhole$data$d2 = _resSolarWhole$data$d[0]) === null || _resSolarWhole$data$d2 === void 0 ? void 0 : _resSolarWhole$data$d2.data;
                _context7.next = 6;
                return getBmsWholePlantSumApi();
              case 6:
                resBmsWhole = _context7.sent;
                bmsWholeData = resBmsWhole === null || resBmsWhole === void 0 ? void 0 : (_resBmsWhole$data = resBmsWhole.data) === null || _resBmsWhole$data === void 0 ? void 0 : (_resBmsWhole$data$dat = _resBmsWhole$data.data) === null || _resBmsWhole$data$dat === void 0 ? void 0 : (_resBmsWhole$data$dat2 = _resBmsWhole$data$dat[0]) === null || _resBmsWhole$data$dat2 === void 0 ? void 0 : _resBmsWhole$data$dat2.data;
                _context7.next = 10;
                return getPowerWholePlantSumApi();
              case 10:
                resPowerWhole = _context7.sent;
                powerWholeData = resPowerWhole === null || resPowerWhole === void 0 ? void 0 : (_resPowerWhole$data = resPowerWhole.data) === null || _resPowerWhole$data === void 0 ? void 0 : (_resPowerWhole$data$d = _resPowerWhole$data.data) === null || _resPowerWhole$data$d === void 0 ? void 0 : (_resPowerWhole$data$d2 = _resPowerWhole$data$d[0]) === null || _resPowerWhole$data$d2 === void 0 ? void 0 : _resPowerWhole$data$d2.data;
                _this8.dataMap.set('whole', {
                  mysqlInfo: bmsWholeData,
                  solarInfo: solarWholeData,
                  powerInfo: powerWholeData
                });
              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    getSingleData: function getSingleData() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var siteInfo, siteName, types, solarInfo, mysqlInfo, powerInfo, _resSolarSingle$data, _resSolarSingle$data$, _resSolarSingle$data$2, resSolarSingle, solarSingleData, _resBmsSingle$data, _resBmsSingle$data$da, _resBmsSingle$data$da2, resBmsSingle, bmsSingleData, _resPowerSingle$data, _resPowerSingle$data$, _resPowerSingle$data$2, resPowerSingle, powerSingleData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this9.clickedSiteInfo) {
                  _context8.next = 2;
                  break;
                }
                return _context8.abrupt("return");
              case 2:
                siteInfo = _this9.clickedSiteInfo;
                siteName = siteInfo.name; // 用共用的 name (siteInfo 外層 name) 當 key
                types = siteInfo.types;
                solarInfo = siteInfo.solarInfo, mysqlInfo = siteInfo.mysqlInfo, powerInfo = siteInfo.powerInfo;
                if (!types.includes('solarInfo')) {
                  _context8.next = 19;
                  break;
                }
                _context8.prev = 7;
                _context8.next = 10;
                return getSolarSinglePlantSumApi(solarInfo.id);
              case 10:
                resSolarSingle = _context8.sent;
                solarSingleData = resSolarSingle === null || resSolarSingle === void 0 ? void 0 : (_resSolarSingle$data = resSolarSingle.data) === null || _resSolarSingle$data === void 0 ? void 0 : (_resSolarSingle$data$ = _resSolarSingle$data.data) === null || _resSolarSingle$data$ === void 0 ? void 0 : (_resSolarSingle$data$2 = _resSolarSingle$data$[0]) === null || _resSolarSingle$data$2 === void 0 ? void 0 : _resSolarSingle$data$2.data;
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  solarInfo: solarSingleData
                }));
                _context8.next = 19;
                break;
              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](7);
                console.log('getSolarSinglePlantSumApi error', _context8.t0);
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  solarInfo: null
                }));
              case 19:
                if (!types.includes('mysqlInfo')) {
                  _context8.next = 32;
                  break;
                }
                _context8.prev = 20;
                _context8.next = 23;
                return getBmsSinglePlantSumApi(mysqlInfo.id);
              case 23:
                resBmsSingle = _context8.sent;
                bmsSingleData = resBmsSingle === null || resBmsSingle === void 0 ? void 0 : (_resBmsSingle$data = resBmsSingle.data) === null || _resBmsSingle$data === void 0 ? void 0 : (_resBmsSingle$data$da = _resBmsSingle$data.data) === null || _resBmsSingle$data$da === void 0 ? void 0 : (_resBmsSingle$data$da2 = _resBmsSingle$data$da[0]) === null || _resBmsSingle$data$da2 === void 0 ? void 0 : _resBmsSingle$data$da2.data;
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  mysqlInfo: bmsSingleData
                }));
                _context8.next = 32;
                break;
              case 28:
                _context8.prev = 28;
                _context8.t1 = _context8["catch"](20);
                console.log('getBmsSinglePlantSumApi error', _context8.t1);
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  mysqlInfo: null
                }));
              case 32:
                if (!types.includes('powerInfo')) {
                  _context8.next = 45;
                  break;
                }
                _context8.prev = 33;
                _context8.next = 36;
                return getPowerSinglePlantSumApi(powerInfo.id);
              case 36:
                resPowerSingle = _context8.sent;
                powerSingleData = resPowerSingle === null || resPowerSingle === void 0 ? void 0 : (_resPowerSingle$data = resPowerSingle.data) === null || _resPowerSingle$data === void 0 ? void 0 : (_resPowerSingle$data$ = _resPowerSingle$data.data) === null || _resPowerSingle$data$ === void 0 ? void 0 : (_resPowerSingle$data$2 = _resPowerSingle$data$[0]) === null || _resPowerSingle$data$2 === void 0 ? void 0 : _resPowerSingle$data$2.data;
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  powerInfo: powerSingleData
                }));
                _context8.next = 45;
                break;
              case 41:
                _context8.prev = 41;
                _context8.t2 = _context8["catch"](33);
                console.log('getPowerSinglePlantSumApi error', _context8.t2);
                _this9.dataMap.set(siteName, _objectSpread(_objectSpread({}, _this9.dataMap.get(siteName) || {}), {}, {
                  powerInfo: null
                }));
              case 45:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[7, 15], [20, 28], [33, 41]]);
      }))();
    },
    getSingleInfoData: function getSingleInfoData() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var siteInfo, siteName, types, solarInfo, mysqlInfo, powerInfo, lon, lat, urlProtocol, params, _resSolarSingleTopInf, resSolarSingleTopInfo, solarSingleInfo, _resBmsSingleTopInfo$, resBmsSingleTopInfo, bmsSingleInfo, _resPowerSingleTopInf, resPowerSingleTopInfo, powerSingleInfo;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this10.clickedSiteInfo) {
                  _context9.next = 2;
                  break;
                }
                return _context9.abrupt("return");
              case 2:
                siteInfo = _this10.clickedSiteInfo;
                siteName = siteInfo.name; // 用共用的 name (siteInfo 外層 name) 當 key
                types = siteInfo.types;
                solarInfo = siteInfo.solarInfo, mysqlInfo = siteInfo.mysqlInfo, powerInfo = siteInfo.powerInfo; // get weather
                lon = siteInfo.lon;
                lat = siteInfo.lat;
                if (siteName && lon && lat) {
                  urlProtocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
                  params = new URLSearchParams();
                  params.append('apikey', process.env.VUE_APP_WEATHER_API_KEY);
                  params.append('units', 'metric');
                  params.append('lang', 'zh_TW');
                  params.append('format', 'JSON');
                  params.append('lon', lon);
                  params.append('lat', lat);
                  axios.get("".concat(urlProtocol, "://api.openweathermap.org/data/2.5/weather?").concat(params.toString())).then(function (res) {
                    _this10.weatherData = {
                      temp: res.data.main.temp,
                      status: res.data.weather[0].description,
                      icon: res.data.weather[0].icon
                    };
                  }).catch(function (err) {
                    console.log('getSingleInfoData weather error: ', err);
                  });
                }
                if (!types.includes('solarInfo')) {
                  _context9.next = 22;
                  break;
                }
                _context9.prev = 10;
                _context9.next = 13;
                return getSolarTopInformationApi({
                  fId: solarInfo.id,
                  factoryName: solarInfo.name
                });
              case 13:
                resSolarSingleTopInfo = _context9.sent;
                solarSingleInfo = resSolarSingleTopInfo === null || resSolarSingleTopInfo === void 0 ? void 0 : (_resSolarSingleTopInf = resSolarSingleTopInfo.data) === null || _resSolarSingleTopInf === void 0 ? void 0 : _resSolarSingleTopInf.data;
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  solarInfo: solarSingleInfo
                }));
                _context9.next = 22;
                break;
              case 18:
                _context9.prev = 18;
                _context9.t0 = _context9["catch"](10);
                console.log('getSolarTopInformationApi error', _context9.t0);
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  solarInfo: null
                }));
              case 22:
                if (!types.includes('mysqlInfo')) {
                  _context9.next = 35;
                  break;
                }
                _context9.prev = 23;
                _context9.next = 26;
                return getBmsTopInformationApi({
                  factoryId: mysqlInfo.id
                });
              case 26:
                resBmsSingleTopInfo = _context9.sent;
                bmsSingleInfo = resBmsSingleTopInfo === null || resBmsSingleTopInfo === void 0 ? void 0 : (_resBmsSingleTopInfo$ = resBmsSingleTopInfo.data) === null || _resBmsSingleTopInfo$ === void 0 ? void 0 : _resBmsSingleTopInfo$.data;
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  mysqlInfo: bmsSingleInfo
                }));
                _context9.next = 35;
                break;
              case 31:
                _context9.prev = 31;
                _context9.t1 = _context9["catch"](23);
                console.log('getBmsTopInformationApi error', _context9.t1);
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  mysqlInfo: null
                }));
              case 35:
                if (!types.includes('powerInfo')) {
                  _context9.next = 48;
                  break;
                }
                _context9.prev = 36;
                _context9.next = 39;
                return getPowerTopInformationApi({
                  fieldName: powerInfo.name
                });
              case 39:
                resPowerSingleTopInfo = _context9.sent;
                powerSingleInfo = resPowerSingleTopInfo === null || resPowerSingleTopInfo === void 0 ? void 0 : (_resPowerSingleTopInf = resPowerSingleTopInfo.data) === null || _resPowerSingleTopInf === void 0 ? void 0 : _resPowerSingleTopInf.data;
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  powerInfo: powerSingleInfo
                }));
                _context9.next = 48;
                break;
              case 44:
                _context9.prev = 44;
                _context9.t2 = _context9["catch"](36);
                console.log('getPowerTopInformationApi error', _context9.t2);
                _this10.topInfoMap.set(siteName, _objectSpread(_objectSpread({}, _this10.topInfoMap.get(siteName) || {}), {}, {
                  powerInfo: null
                }));
              case 48:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[10, 18], [23, 31], [36, 44]]);
      }))();
    },
    getSingleAnalysisChartData: function getSingleAnalysisChartData() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var siteInfo, siteName, types, solarInfo, powerInfo, lon, lat, urlProtocol, params, _resSolarSingleAnalys, resSolarSingleAnalysis, solarSingleAnalysis, _resPowerSingleAnalys, resPowerSingleAnalysis, powerSingleAnalysis;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (_this11.clickedSiteInfo) {
                  _context10.next = 2;
                  break;
                }
                return _context10.abrupt("return");
              case 2:
                siteInfo = _this11.clickedSiteInfo;
                siteName = siteInfo.name; // 用共用的 name (siteInfo 外層 name) 當 key
                types = siteInfo.types;
                solarInfo = siteInfo.solarInfo, powerInfo = siteInfo.powerInfo; // get weather
                lon = siteInfo.lon;
                lat = siteInfo.lat;
                if (!(siteName && lon && lat)) {
                  _context10.next = 17;
                  break;
                }
                urlProtocol = process.env.NODE_ENV === 'development' ? 'http' : 'https';
                params = new URLSearchParams();
                params.append('latitude', lat);
                params.append('longitude', lon);
                params.append('timezone', 'Asia/Taipei');
                params.append('hourly', 'temperature_2m,weather_code'); // temperature_2m 量測高度 2 公尺
                _context10.next = 17;
                return axios.get("".concat(urlProtocol, "://api.open-meteo.com/v1/forecast?").concat(params.toString())).then(function (res) {
                  var _res$data, _res$data$hourly, _res$data$hourly$temp, _res$data2, _res$data2$hourly, _res$data2$hourly$wea;
                  _this11.hourlyWeatherData = {
                    temp: ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$hourly = _res$data.hourly) === null || _res$data$hourly === void 0 ? void 0 : (_res$data$hourly$temp = _res$data$hourly.temperature_2m) === null || _res$data$hourly$temp === void 0 ? void 0 : _res$data$hourly$temp.slice(0, 24)) || [],
                    weatherCode: ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$hourly = _res$data2.hourly) === null || _res$data2$hourly === void 0 ? void 0 : (_res$data2$hourly$wea = _res$data2$hourly.weather_code) === null || _res$data2$hourly$wea === void 0 ? void 0 : _res$data2$hourly$wea.slice(0, 24)) || []
                  };
                }).catch(function (err) {
                  console.log('getSingleAnalysisChartData weather error: ', err);
                });
              case 17:
                if (!types.includes('solarInfo')) {
                  _context10.next = 30;
                  break;
                }
                _context10.prev = 18;
                _context10.next = 21;
                return getSolarAnalysisChartsApi(solarInfo.id);
              case 21:
                resSolarSingleAnalysis = _context10.sent;
                solarSingleAnalysis = resSolarSingleAnalysis === null || resSolarSingleAnalysis === void 0 ? void 0 : (_resSolarSingleAnalys = resSolarSingleAnalysis.data) === null || _resSolarSingleAnalys === void 0 ? void 0 : _resSolarSingleAnalys.data;
                _this11.analysisChartMap.set(siteName, _objectSpread(_objectSpread({}, _this11.analysisChartMap.get(siteName) || {}), {}, {
                  solarInfo: solarSingleAnalysis
                }));
                _context10.next = 30;
                break;
              case 26:
                _context10.prev = 26;
                _context10.t0 = _context10["catch"](18);
                console.log('getSolarAnalysisChartsApi error', _context10.t0);
                _this11.analysisChartMap.set(siteName, _objectSpread(_objectSpread({}, _this11.analysisChartMap.get(siteName) || {}), {}, {
                  solarInfo: null
                }));
              case 30:
                if (!types.includes('powerInfo')) {
                  _context10.next = 43;
                  break;
                }
                _context10.prev = 31;
                _context10.next = 34;
                return getPowerAnalysisChartsApi({
                  fieldId: powerInfo.id,
                  fieldName: powerInfo.name
                });
              case 34:
                resPowerSingleAnalysis = _context10.sent;
                powerSingleAnalysis = resPowerSingleAnalysis === null || resPowerSingleAnalysis === void 0 ? void 0 : (_resPowerSingleAnalys = resPowerSingleAnalysis.data) === null || _resPowerSingleAnalys === void 0 ? void 0 : _resPowerSingleAnalys.data;
                _this11.analysisChartMap.set(siteName, _objectSpread(_objectSpread({}, _this11.analysisChartMap.get(siteName) || {}), {}, {
                  powerInfo: powerSingleAnalysis
                }));
                _context10.next = 43;
                break;
              case 39:
                _context10.prev = 39;
                _context10.t1 = _context10["catch"](31);
                console.log('getPowerAnalysisChartsApi error', _context10.t1);
                _this11.analysisChartMap.set(siteName, _objectSpread(_objectSpread({}, _this11.analysisChartMap.get(siteName) || {}), {}, {
                  powerInfo: null
                }));
              case 43:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[18, 26], [31, 39]]);
      }))();
    },
    setChartData: function setChartData() {
      var _this12 = this;
      var data = [];
      var key = this.selectedSiteName || 'whole';
      this.siteTypes.forEach(function (type, typeIdx) {
        var _this12$dataMap$get;
        var chartData = (_this12$dataMap$get = _this12.dataMap.get(key)) === null || _this12$dataMap$get === void 0 ? void 0 : _this12$dataMap$get[type];
        switch (type) {
          case 'solarInfo':
            data[typeIdx] = clonedeep(solarCharts); // chart 基礎內容

            if (chartData) {
              // chart [0] 同期發電量比較
              data[typeIdx][0].xAxis.categories = chartData.time;
              data[typeIdx][0].series[0].data = chartData.energyTwoYears.lastYear;
              data[typeIdx][0].series[1].data = chartData.energyTwoYears.thisYear;
              // chart [1] 每月發電量
              data[typeIdx][1].xAxis.categories = chartData.time;
              data[typeIdx][1].series[0].data = chartData.energyGrowthRate12Months.acp;
              data[typeIdx][1].series[1].data = chartData.energyGrowthRate12Months.accumulated;
              // chart [2] 每月減碳量
              data[typeIdx][2].xAxis.categories = chartData.time;
              data[typeIdx][2].series[0].data = chartData.carbonReduction12Months.values;
              // chart [3] 每月發電收入
              data[typeIdx][3].xAxis.categories = chartData.time;
              data[typeIdx][3].series[0].data = chartData.income12Months.values;
            }
            break;
          case 'mysqlInfo':
            data[typeIdx] = clonedeep(bmsCharts);
            if (chartData) {
              // chart [0] 單體電壓/溫度分布
              // <-> 兩種方法設定 tooltip 顯示時間
              // data[typeIdx][0].xAxis.categories =
              //   bmsWholeData.voltageTemperatureDistribution.time
              data[typeIdx][0].series[0].timeArr = chartData.voltageTemperatureDistribution.time;
              data[typeIdx][0].series[0].data = chartData.voltageTemperatureDistribution.data;
              // chart [1] 每月充放電比率
              data[typeIdx][1].xAxis.categories = chartData.chargingRatioLast30Days.time;
              data[typeIdx][1].series[0].data = chartData.chargingRatioLast30Days.percentage;
              data[typeIdx][1].series[1].data = chartData.chargingRatioLast30Days.ranges;
              // chart [2] 案場建置數量/容量
              data[typeIdx][2].xAxis.categories = chartData.siteInstallationCapacity.time;
              data[typeIdx][2].series[0].data = chartData.siteInstallationCapacity.sitesNum;
              data[typeIdx][2].series[1].data = chartData.siteInstallationCapacity.capacity;
              // chart [3] 每月充放電量
              data[typeIdx][3].xAxis.categories = chartData.monthlyChargeDischargeTotal.time;
              data[typeIdx][3].series[0].data = chartData.monthlyChargeDischargeTotal.ch_kWh;
              data[typeIdx][3].series[1].data = chartData.monthlyChargeDischargeTotal.kWh;
            }
            break;
          case 'powerInfo':
            data[typeIdx] = clonedeep(powerCharts);
            if (chartData) {
              // chart [0] 今日/昨日用電量
              data[typeIdx][0].xAxis.categories = chartData.todayYesterdayConsumption.time;
              data[typeIdx][0].series[0].data = chartData.todayYesterdayConsumption.yesterday;
              data[typeIdx][0].series[1].data = chartData.todayYesterdayConsumption.today;
              // chart [1] 電量小時K線圖
              data[typeIdx][1].xAxis.categories = chartData.hourlyCandlestickLast24Hours.time;
              var timeArr = chartData.hourlyCandlestickLast24Hours.time;
              var firstArr = chartData.hourlyCandlestickLast24Hours.first;
              var maxArr = chartData.hourlyCandlestickLast24Hours.max;
              var minArr = chartData.hourlyCandlestickLast24Hours.min;
              var lastArr = chartData.hourlyCandlestickLast24Hours.last;
              data[typeIdx][1].series[0].data = timeArr.map(function (time, timeIdx) {
                return [time, firstArr[timeIdx], maxArr[timeIdx], minArr[timeIdx], lastArr[timeIdx]];
              });
              // chart [2] 本月用電量(日)
              data[typeIdx][2].xAxis.categories = chartData.dailyConsumptionLast30Days.time;
              data[typeIdx][2].series[0].data = chartData.dailyConsumptionLast30Days.values;
              // chart [3] 本月累積用電量(日)
              data[typeIdx][3].xAxis.categories = chartData.cumulativeDailyConsumptionLast30Days.time;
              data[typeIdx][3].series[0].data = chartData.cumulativeDailyConsumptionLast30Days.values;
              data[typeIdx][3].series[1].data = chartData.cumulativeDailyConsumptionLast30Days.accumulated;
            }
            break;
        }
      });
      this.chartDatasets = data;
    },
    setTopInfoBasicData: function setTopInfoBasicData() {
      // for skeleton loading
      var data = [];
      this.siteTypes.forEach(function (type, typeIdx) {
        switch (type) {
          case 'solarInfo':
            data[typeIdx] = clonedeep(solarInfoBasic);
            break;
          case 'mysqlInfo':
            data[typeIdx] = clonedeep(bmsInfoBasic);
            break;
          case 'powerInfo':
            data[typeIdx] = clonedeep(powerInfoBasic);
            break;
        }
      });
      this.topInfoBasicDatasets = data;
    },
    setTopInfoData: function setTopInfoData() {
      var _this13 = this;
      if (!this.clickedSiteInfo) return;
      var data = clonedeep(this.topInfoBasicDatasets);
      this.siteTypes.forEach(function (type, typeIdx) {
        var _this13$topInfoMap$ge;
        var topInfoData = (_this13$topInfoMap$ge = _this13.topInfoMap.get(_this13.selectedSiteName)) === null || _this13$topInfoMap$ge === void 0 ? void 0 : _this13$topInfoMap$ge[type];
        switch (type) {
          case 'solarInfo':
            data[typeIdx].weather.temp = _this13.weatherData.temp;
            data[typeIdx].weather.status = _this13.weatherData.status;
            data[typeIdx].weather.icon = _this13.weatherData.icon;
            if (topInfoData) {
              data[typeIdx].list[0].value = toTwoDecimals(topInfoData.IRR);
              data[typeIdx].list[1].value = toTwoDecimals(topInfoData.IRRSum);
              data[typeIdx].list[2].value = toTwoDecimals(topInfoData.peakWatt);
              data[typeIdx].list[3].value = toTwoDecimals(topInfoData.prSum * 100);

              // TODO: 此 api 沒有 timestamp, 這會自動變成現在時間
              data[typeIdx].updateTime = dayjs(topInfoData.timestamp).format('YYYY.MM.DD HH:mm:ss');
            }
            break;
          case 'mysqlInfo':
            if (topInfoData) {
              data[typeIdx].list[0].value = toTwoDecimals(topInfoData.BMS.SOC);
              data[typeIdx].list[1].value = toTwoDecimals(topInfoData.PCC_meter.CH_kWh);
              data[typeIdx].list[2].value = toTwoDecimals(topInfoData.PCC_meter.kWh);
              data[typeIdx].list[3].value = toTwoDecimals(topInfoData.BMS.dc_v);
              data[typeIdx].list[4].value = toTwoDecimals(topInfoData.BMS.temp);
              data[typeIdx].status.commStatus[0].status = bmsCommStatusToText[topInfoData.deviceCommStatus.PCS];
              data[typeIdx].status.commStatus[1].status = bmsCommStatusToText[topInfoData.deviceCommStatus.BMS];
              data[typeIdx].status.commStatus[2].status = bmsCommStatusToText[topInfoData.deviceCommStatus.PCC_meter];
              data[typeIdx].updateTime = dayjs(topInfoData.timestamp).format('YYYY.MM.DD HH:mm:ss');
            }
            break;
          case 'powerInfo':
            data[typeIdx].weather.temp = _this13.weatherData.temp;
            data[typeIdx].weather.status = _this13.weatherData.status;
            data[typeIdx].weather.icon = _this13.weatherData.icon;
            if (topInfoData) {
              powerInfoBasic.list.forEach(function (_obj, objIdx) {
                var valueKey = objIdx === 0 ? 'p' : objIdx === 1 ? 'v' : 'i';
                var unit = objIdx === 0 ? 'kW' : objIdx === 1 ? 'V' : 'A';
                data[typeIdx].list[objIdx].subItems = topInfoData.meterData.map(function (item) {
                  return {
                    name: item.position,
                    value: toTwoDecimals(item[valueKey]),
                    unit: unit
                  };
                });
              });
              data[typeIdx].updateTime = dayjs(topInfoData.timestamp).format('YYYY.MM.DD HH:mm:ss');
            }
            break;
        }
      });
      this.topInfoDatasets = data;
    },
    setAnalysisChartData: function setAnalysisChartData() {
      var _this14 = this;
      if (!this.clickedSiteInfo) return;
      var data = [];
      this.siteTypes.forEach(function (type, typeIdx) {
        var _this14$analysisChart;
        var analysisChartData = (_this14$analysisChart = _this14.analysisChartMap.get(_this14.selectedSiteName)) === null || _this14$analysisChart === void 0 ? void 0 : _this14$analysisChart[type];
        switch (type) {
          case 'solarInfo':
            data[typeIdx] = clonedeep(solarAnalysisCharts);
            var hourlyData = analysisChartData === null || analysisChartData === void 0 ? void 0 : analysisChartData.hourlyData;
            var heatMapData = analysisChartData === null || analysisChartData === void 0 ? void 0 : analysisChartData.heatMapData;
            var dailyData = analysisChartData === null || analysisChartData === void 0 ? void 0 : analysisChartData.dailyData;

            // chart0
            if (hourlyData) {
              var timeArr = Object.keys(hourlyData);
              data[typeIdx][0].categories = timeArr;
              data[typeIdx][0].acpData = timeArr.map(function (time) {
                return isNumber(hourlyData[time].acp) ? Math.round(hourlyData[time].acp * 100) / 100 : null;
              });
              data[typeIdx][0].irrData = timeArr.map(function (time) {
                return isNumber(hourlyData[time].IRR) ? Math.round(hourlyData[time].IRR * 100) / 100 : null;
              });
              data[typeIdx][0].prData = timeArr.map(function (time) {
                return isNumber(hourlyData[time].pr) ? Math.round(hourlyData[time].pr * 10000) / 100 : null;
              });
              data[typeIdx][0].weatherData = _this14.hourlyWeatherData.temp.map(function (temp, idx) {
                return {
                  y: temp,
                  weatherCode: _this14.hourlyWeatherData.weatherCode[idx]
                };
              });
            }

            // chart1
            if (heatMapData) {
              // 00:00, 00:15, 00:30, 00:45 ... 23:45
              var heapMapTimeArr = heatMapData.reduce(function (accu, _curr, hhmmIdx) {
                return [].concat(_toConsumableArray(accu), _toConsumableArray(Array.from({
                  length: 4
                },
                // FIXME: API 不知為甚麼 kWp 會有 5 個
                // { length: curr.kWp.length },
                function (_, kWpIdx) {
                  return "".concat(hhmmIdx).padStart(2, '0') + ':' + "".concat(15 * kWpIdx).padStart(2, '0');
                })));
              }, []);
              // invNo: 5,4,3,2,1
              var invNoArr = Array.from({
                length: heatMapData[0].kWp[0].length
              }, function (_, i) {
                return i + 1;
              }).reverse();
              data[typeIdx][1].xCats = heapMapTimeArr;
              // INV05, INV04, INV03, INV02, INV01
              data[typeIdx][1].yCats = invNoArr.map(function (invNo) {
                return 'INV' + "".concat(invNo).padStart(2, '0');
              });
              heapMapTimeArr.forEach(function (time, xAxisIndex) {
                var foundTimeIndex = heatMapData.findIndex(function (item) {
                  return item.hhmm === time;
                });
                if (foundTimeIndex !== -1) {
                  var foundTimeData = heatMapData[foundTimeIndex];

                  // inv
                  invNoArr.forEach(function (_inv, yAxisIndex) {
                    // 時間區間 00 15 30 45
                    Array.from({
                      length: 4
                    }).forEach(function (_, periodIdx) {
                      var kWp = foundTimeData.kWp[periodIdx];
                      var peakWatt = kWp ? kWp[invNoArr[yAxisIndex] - 1] : null;
                      data[typeIdx][1].data.push([xAxisIndex + periodIdx, yAxisIndex, isNumber(peakWatt) ? Math.round(peakWatt * 100) / 100 : null]);
                    });
                  });
                }
              });
            }

            // chart2
            if (dailyData) {
              var dayArr = Object.keys(dailyData).reverse();
              // .sort((a, b) => dayjs(a).unix() - dayjs(b).unix())

              data[typeIdx][2].categories = dayArr;
              data[typeIdx][2].acpData = dayArr.map(function (day) {
                return isNumber(dailyData[day].acp) ? Math.round(dailyData[day].acp * 100) / 100 : null;
              });
              data[typeIdx][2].irrData = dayArr.map(function (day) {
                return isNumber(dailyData[day].IRR) ? Math.round(dailyData[day].IRR * 100) / 100 : null;
              });
            }
            break;
          case 'powerInfo':
            data[typeIdx] = clonedeep(powerAnalysisCharts);
            var PFAndPData = analysisChartData === null || analysisChartData === void 0 ? void 0 : analysisChartData.PFAndPData;
            var meterKwhByDay = analysisChartData === null || analysisChartData === void 0 ? void 0 : analysisChartData.meterKwhByDay;
            if (PFAndPData) {
              var positions = PFAndPData.map(function (obj) {
                return obj.position;
              });
              var meterIds = PFAndPData.map(function (obj) {
                return obj.meterId;
              });

              // chart3
              data[typeIdx][0].categories = meterKwhByDay.map(function (obj) {
                return obj.date;
              });
              data[typeIdx][0].series = meterIds.map(function (meterId, idx) {
                return {
                  name: positions[idx],
                  data: meterKwhByDay.map(function (obj) {
                    return obj.power[meterId];
                  })
                };
              });

              // chart4
              data[typeIdx][1].series = positions.map(function (position, idx) {
                return {
                  name: position,
                  data: PFAndPData[idx].data.map(function (obj) {
                    return [dayjs(obj.timestamp).valueOf(), obj.P];
                  })
                };
              });

              // chart5
              data[typeIdx][2].categories = PFAndPData[0].data.map(function (obj) {
                return dayjs(obj.timestamp).format('HH:mm');
              });
              data[typeIdx][2].series = positions.map(function (position, idx) {
                return {
                  name: position,
                  data: PFAndPData[idx].data.map(function (obj) {
                    return obj.PF;
                  })
                };
              });
            }
            break;
        }
      });
      this.analysisChartDatasets = data;
    },
    trackMouse: function trackMouse(event) {
      // 使用者最後的實際滑鼠座標
      this.cursorX = event.clientX;
      this.cursorY = event.clientY;

      // 讓假游標跟隨顯示（可選，通常在 idle 前會隱藏）
      var fakeCursor = this.$refs.fakeCursor;
      fakeCursor.style.left = "".concat(this.cursorX, "px");
      fakeCursor.style.top = "".concat(this.cursorY, "px");
    },
    moveCursorTo: function moveCursorTo(element) {
      var _arguments = arguments,
        _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var offsetX, offsetY;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                offsetX = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 3;
                offsetY = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : 5;
                if (!_this15.isSecretQuickAutoplay) {
                  _context11.next = 7;
                  break;
                }
                _context11.next = 5;
                return delay(0.5);
              case 5:
                _context11.next = 9;
                break;
              case 7:
                _context11.next = 9;
                return delay(1);
              case 9:
                return _context11.abrupt("return", new Promise(function (resolve) {
                  var rect = element.getBoundingClientRect();
                  var targetX = rect.left + rect.width / 2 + offsetX; // offset 仿滑鼠偏移, 不會在正中間
                  var targetY = rect.top + rect.height / 2 + offsetY;
                  var fakeCursor = _this15.$refs.fakeCursor;

                  // 從上次的位置開始移動
                  var currentX = _this15.cursorX || 0;
                  var currentY = _this15.cursorY || 0;
                  var steps = _this15.isSecretQuickAutoplay ? 20 : 50; // 移動分幾步
                  var count = 0;

                  // 滑鼠移動 - 緩動函數
                  //  easeOutQuad 緩動函數
                  function easeOutQuad(t) {
                    return t * (2 - t);
                  }
                  var timer = setInterval(function () {
                    // 計算進度（0 到 1）
                    // const progress = Math.min(count / steps, 1) // 確保不超過 1
                    // 應用緩動函數
                    // const easedProgress = easeOutQuad(progress)
                    var easedProgress = easeOutQuad(count / steps);

                    // 使用線性插值（Lerp）計算當前位置
                    currentX = currentX + (targetX - currentX) * easedProgress;
                    currentY = currentY + (targetY - currentY) * easedProgress;
                    fakeCursor.style.left = "".concat(currentX, "px");
                    fakeCursor.style.top = "".concat(currentY, "px");
                    count++;
                    if (count >= steps) {
                      clearInterval(timer);

                      // 確保最後到正確位置
                      _this15.cursorX = targetX;
                      _this15.cursorY = targetY;
                      fakeCursor.style.left = "".concat(targetX, "px");
                      fakeCursor.style.top = "".concat(targetY, "px");

                      // 移動完成後停頓, 再後續動作 click / dispatchEvent 等
                      delay(_this15.isSecretQuickAutoplay ? 0.2 : 0.3).then(resolve);
                    }
                  }, 20);

                  // 滑鼠移動 - 直線
                  // const dx = (targetX - currentX) / steps
                  // const dy = (targetY - currentY) / steps

                  // const timer = setInterval(async () => {
                  //   currentX += dx
                  //   currentY += dy
                  //   fakeCursor.style.left = `${currentX}px`
                  //   fakeCursor.style.top = `${currentY}px`

                  //   count++
                  //   if (count >= steps) {
                  //     clearInterval(timer)

                  //     // 確保最後到正確位置
                  //     this.cursorX = targetX
                  //     this.cursorY = targetY
                  //     fakeCursor.style.left = `${targetX}px`
                  //     fakeCursor.style.top = `${targetY}px`

                  //     // 移動完成後停頓, 再後續動作 click / dispatchEvent 等
                  //     delay(0.3).then(resolve)
                  //   }
                  // }, 20)
                }));
              case 10:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    autoplayOverviewPage: function autoplayOverviewPage() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(_this16.autoplayPageIdx === 0)) {
                  _context12.next = 14;
                  break;
                }
                if (_this16.selectedSiteName) {
                  _context12.next = 7;
                  break;
                }
                _context12.next = 4;
                return _this16.moveCursorTo(_this16.$refs.infoContent, 100, -45);
              case 4:
                _this16.allBackToOverview(); // 返回首頁
                _context12.next = 12;
                break;
              case 7:
                _context12.next = 9;
                return _this16.moveCursorTo(_this16.$refs.replyButton);
              case 9:
                _this16.allBackToOverview(); // 返回首頁
                _context12.next = 12;
                return _this16.moveCursorTo(_this16.$refs.infoContent, 80, -30);
              case 12:
                _context12.next = 16;
                break;
              case 14:
                // console.log('總覽輪播 第1頁以外')
                _this16.currentPageIdx = _this16.autoplayPageIdx;
                _this16.updateAndShowChart();
              case 16:
                _this16.autoplayPageIdx++;
              case 17:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    autoplaySitePage: function autoplaySitePage() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_this17.autoplaySiteIdx !== 0)) {
                  _context13.next = 4;
                  break;
                }
                _context13.next = 3;
                return _this17.moveCursorTo(_this17.$refs.replyButton);
              case 3:
                _this17.resetMap();
              case 4:
                _context13.next = 6;
                return _this17.focusSiteBySiteId(_this17.settings.siteIds[_this17.autoplaySiteIdx], true);
              case 6:
                _this17.autoplaySiteIdx++;
                // console.timeEnd('autoplaySitePage')
              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    resetAutoplayIdx: function resetAutoplayIdx() {
      this.autoplayPageIdx = 0;
      this.autoplaySiteIdx = 0;
    },
    handleStartAutoClick: function handleStartAutoClick() {
      if (!this.hasSecretAutoplay) return;
      this.isSecretQuickAutoplay = true;
      this.startAutoplay();
    },
    startAutoplay: function startAutoplay() {
      var _this18 = this;
      if (!this.settings.openDemo || this.isMapLoading) return;
      if (!this.autoDemoTimer) {
        // 關閉 modal
        this.isOpenModal = false;
        this.isOpenSettingsModal = false;
        this.idleText = '案場資訊輪播中';
        document.querySelector('.cursor').style.display = 'none'; // 隱藏使用者游標
        this.$refs.fakeCursor.style.display = 'block'; // 顯示假滑鼠

        // 重置 idx
        this.resetAutoplayIdx();
        this.autoplayOverviewPage(); // 先執行一次

        // 每經過秒數後執行
        this.autoDemoTimer = setInterval(function () {
          // 總覽輪播 -> 案場輪播 (循環)
          var autoplayPageNum = _this18.isSecretQuickAutoplay ? 1 // 快速輪播只播放太陽能
          : _this18.siteTypes.length;
          if (_this18.autoplayPageIdx < autoplayPageNum) {
            // console.log('總覽輪播')
            _this18.autoplayOverviewPage();
          } else if (_this18.autoplaySiteIdx < _this18.settings.siteIds.length) {
            // console.log('案場輪播')
            _this18.autoplaySitePage();
          } else {
            _this18.resetAutoplayIdx();
            _this18.autoplayOverviewPage();
          }
        }, this.checkedIntervalSeconds);
      }
    },
    stopAutoplay: function stopAutoplay() {
      if (this.autoDemoTimer) {
        clearInterval(this.autoDemoTimer);
        this.autoDemoTimer = null;
      }
      this.idleText = '';
      if (this.$refs.fakeCursor) {
        this.$refs.fakeCursor.style.display = 'none'; // 隱藏假滑鼠
      }
      var userCursor = document.querySelector('.cursor');
      if (userCursor) userCursor.style.display = 'block'; // 顯示使用者游標
      // this.allBackToOverview() // 返回首頁(避免剩下的動畫繼續執行)
    },
    resetIdleTimer: function resetIdleTimer() {
      var _this19 = this;
      this.stopAutoplay();
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(function () {
        _this19.startAutoplay();
      }, this.checkedIdleSeconds);
    }
  }
};